import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap'
import { message } from 'antd'
import moment from 'moment'
import 'moment/locale/es'

import { getUri } from '../../../services/springCenfApi'
import { storeDownloadToken } from '../../DownloadTokens/services'
import { handleError, serialize } from '../../../helpers'

export default function ExportAppointmentsModal({ visible, onClose }) {
    const user_id = useSelector(state => state.auth.user.id)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [loading, setLoading] = useState(false)

    const onSubmit = values => {
        setLoading(true)
        let token = new Date().getTime()
		storeDownloadToken({ type: `Listado de Citas Agendadas`, token, user_id })
			.then(() => {
				message.info('Generando archivo en nueva pestaña')
				window.open(`${getUri()}/reports/export/appointments/${token}?${serialize(values)}`)
				onClose()
			})
			.catch(error => handleError(error, setLoading))
    }

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Exportar Citas</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Form.Group className='form-group' as={Col}>
                            <Form.Label>Mes que desea exportar <span className='text-danger'>*</span></Form.Label>
                            <Form.Control 
                                as="select"
                                {...register('month', { required: true })} 
                            >
                                <option value="">:: Seleccione un mes ::</option>
                                { [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
                                    <option key={month} value={month}>{moment().month(month - 1).format('MMMM').charAt(0).toUpperCase() + moment().month(month - 1).format('MMMM').slice(1)}</option>
                                ))}
                            </Form.Control>
                            { errors.month && (
                                <Form.Text className='text-warning'>Este campo es requerido</Form.Text>
                            )}
                        </Form.Group>
                        <Form.Group className='form-group' as={Col}>
                            <Form.Label>Año que desea exportar <span className='text-danger'>*</span></Form.Label>
                            <Form.Control 
                                as="select"
                                {...register('year', { required: true })} 
                            >
                                <option value="">:: Seleccione un año ::</option>
                                { [2025, 2026].map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                            { errors.month && (
                                <Form.Text className='text-warning'>Este campo es requerido</Form.Text>
                            )}
                        </Form.Group>
                    </Row>
                    <Button type="submit" disabled={loading}>
                        { loading && <Spinner animation='border' size="sm" className='mr-5' /> }
                        Exportar Listado
                    </Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}